/* apps/IDSImpactApp/src/app/app.component.css */
/*# sourceMappingURL=app.component.css.map */
